export const getStatusColor = (status) => {
    switch (status) {
        case 'in_progress':
            return 'primary'; // Blue for ongoing games
        case 'end':
            return 'success'; // Green for finished games
        case 'error':
            return 'error';   // Red for errored games
        default:
            return 'default'; // A neutral default color
    }
};

// This function maps the winning result to a Material-UI color prop.
export const getWinningColor = (winning) => {
    switch (winning) {
        case 'win':
            return 'success'; // Green for a win
        case 'lose':
            return 'error';   // Red for a loss
        default:
            return 'default'; // A neutral default color
    }
};

export const formatPlayerName = (player, useShort = true) => {
    if (!player || !player.id) {
        return '—';
    }
    const {id, name, email} = player;
    const shortId = useShort ? `${String(id).slice(0, 8)}…` : id;
    if (name) {
        return email ? `${name} <${email}>` : name;
    }
    if (email) {
        return `${shortId} <${email}>`;
    }
    return shortId;
};

export const formatLastSeen = (ts) => {
    if (!ts) return '—';
    const diff = Date.now() - new Date(ts).getTime();

    // Less than a minute ago
    if (diff < 60000) {
        return `${new Date(ts).toLocaleString()}, ${Math.floor(diff / 1000)} sec ago`;
    }
    // Less than an hour ago
    if (diff < 3600000) {
        return `${new Date(ts).toLocaleString()}, ${Math.floor(diff / 60000)} min ago`;
    }
    // Otherwise, show the full date and time
    return new Date(ts).toLocaleString();
};

export const getMachineStateColor = (state) => {
    if (state === 'online') return 'success';
    if (state === 'offline') return 'error';
    return 'default';
};